import { DashboardWidget } from '../reporting';
import { Account, Counterparty, Currency, TransactionType, Transaction, Config } from "./";
import { BlobContent } from './BlobContent';
import { ExternalFile } from './ExternalFile';

function getTypeName(ref:any) : string {
    if (ref === Currency) {
        return Currency.STORE;
    }
    if (ref === Counterparty) {
        return Counterparty.STORE;
    }
    if (ref === Transaction) {
        return Transaction.STORE;
    }
    if (ref === Account) {
        return Account.STORE;
    }
    if (ref === TransactionType) {
        return TransactionType.STORE;
    }
    if (ref === DashboardWidget) {
        return DashboardWidget.STORE;
    }
    if (ref == Config) {
        return Config.STORE;
    }
    if (ref == BlobContent) {
        return BlobContent.STORE;
    }
    if (ref == ExternalFile) {
        return ExternalFile.STORE;
    }
    throw Error(`Unknown ref ${ref}`);
}

export { getTypeName }